import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { TabPanel, TabView } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BreadcrumbComponent from '../../../components/Breadcrumb';

const TenantView: React.FC = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const tenant = location.state?.tenant;

    function handleBack(): void {
        navigate(`/admin/tenant`);
    }
    const toolbarTemplate = () => {
        return (
            <>
                {/* <Button label="Save" icon="pi pi-check" style={{ marginRight: '.5em' }} onClick={() => handleSave()} /> */}
                {/* <Button label="Delete" icon="pi pi-trash" style={{ marginRight: '.5em' }} /> */}
                <Button label="Back" icon="pi pi-times" style={{ marginRight: '.5em' }} onClick={() => handleBack()} />

            </>
        );
    };

    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        return date.toLocaleString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hourCycle: "h23",
            timeZone: "Asia/Kuala_Lumpur",
        }).replace(", ", " ");
    };

    return (
        <div>
            <div className='card-title'>
                <h5>Facility Form</h5>
                <BreadcrumbComponent />
            </div>

            <div className='card'>
                <Accordion activeIndex={0}>
                    <AccordionTab header="Facility Information">
                        <div className="p-fluid form-grid grid">
                            <div className="field col-12 md:col-6">
                                <label>Facility Code:</label>
                                <p>{tenant.facilityCode || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Facility Full Name:</label>
                                <p>{tenant.fullName || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Facility Short Name:</label>
                                <p>{tenant.shortName || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Registartion No.:</label>
                                <p>{tenant.registrationNo || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Institution Type:</label>
                                <p>{tenant.instType || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Live Date:</label>
                                <p>{formatDate(tenant.liveDate)}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Status:</label>
                                <p>{tenant.recordStatus == '1' ? "Active" : "Inactive"}</p>
                            </div>
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Address Information">
                        <div className="p-fluid form-grid grid">
                            <div className="field col-12 md:col-6">
                                <label>Address:</label>
                                <p>{tenant.address || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Postcode:</label>
                                <p>{tenant.postcode || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>City:</label>
                                <p>{tenant.city || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Country:</label>
                                <p>{tenant.countryCodeHasOne.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>State:</label>
                                <p>{tenant.stateCodeHasOne.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>District:</label>
                                <p>{tenant.districtCodeHasOne.fullDesc || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Telephone No.:</label>
                                <p>{tenant.telephoneNo || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Fax No.:</label>
                                <p>{tenant.faxNo || "N/A"}</p>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Email:</label>
                                <p>{tenant.email || "N/A"}</p>
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>
            <Toolbar end={toolbarTemplate}></Toolbar>
        </div>
    );
};

export default TenantView;